import { DisciplineSchedule } from '../../Components/DisciplineSchedule';

export const BlackPowderSilhouetteSchedule = () => {
  return (
    <DisciplineSchedule 
      discipline="BLACK_POWDER_SILHOUETTE" 
      disciplineName="Black Powder Silhouette"
    />
  );
};
